module.exports = __webpack_public_path__ + "img/icon-limit.2aefe051.svg";